/// <amd-module name="TFS/Admin/Views/AdminRoles/Redux/AdminRolesActions" />
import { createAction, ActionsUnion } from "redux/Utils/ActionHelper";

export const AdminRolesActions = {
    initView: () => createAction(AdminRolesActionTypes.InitView),
    initialLoadSucceeded: () => createAction(AdminRolesActionTypes.InitialLoadSucceeded)
};

export const enum AdminRolesActionTypes {
    InitView = "AdminRoles/Init",
    InitialLoadSucceeded = "AdminRoles/InitialLoadSucceeded"
}

export type AdminRolesActions = ActionsUnion<typeof AdminRolesActions>;
